import { routeDefinitions } from '@/router/route-definitions'
import { useTypedNavigation } from '@/shared/hooks/useTypedNavigate'
import { Typography } from '@/ui/components'
import React from 'react'
import { useLocation } from 'react-router'
import {
  ButtonPanelContainer,
  IconWrapper,
  NavButton,
} from '../../styles/dashboard/ButtonPanel.styles'
import CampaignIcon from '../icons/CampaignIcon'
import HeartIcon from '../icons/HeartIcon'
import HomeIcon from '../icons/HomeIcon'
import ProfileIcon from '../icons/ProfileIcon'

const ButtonPanel: React.FC = () => {
  const location = useLocation()
  const nav = useTypedNavigation()

  const isActive = (path: string) => location.pathname === path
  const isHome = isActive(routeDefinitions.home.path)
  const isCampaign = isActive(routeDefinitions.campaign.path)
  const isProfile = isActive(routeDefinitions.profile.path)

  // ButtonPanel은 MainLayout에서 이미 표시 여부를 결정하므로
  // 여기서는 추가 검증 없이 렌더링

  const goToLineAccount = () => {
    window.open('https://line.me/R/ti/p/%40119uquih', '_blank')
  }

  return (
    <ButtonPanelContainer>
      <NavButton $active={isHome} onClick={() => nav.home()} aria-label="Home">
        <IconWrapper>
          <HomeIcon active={isHome} />
        </IconWrapper>
        <Typography variant="Button/Button-12-semibold">ホーム</Typography>
      </NavButton>
      <NavButton $active={isCampaign} onClick={() => nav.campaign()} aria-label="Campaign">
        <IconWrapper>
          <CampaignIcon active={isCampaign} />
        </IconWrapper>
        <Typography variant="Button/Button-12-semibold">キャンペーン</Typography>
      </NavButton>
      <NavButton $active={false} onClick={() => goToLineAccount()} aria-label="Search">
        <IconWrapper>
          <HeartIcon active={false} />
        </IconWrapper>
        <Typography variant="Button/Button-12-semibold">検索</Typography>
      </NavButton>
      <NavButton $active={isProfile} onClick={() => nav.profile()} aria-label="Profile">
        <IconWrapper>
          <ProfileIcon active={isProfile} />
        </IconWrapper>
        <Typography variant="Button/Button-12-semibold">マイページ</Typography>
      </NavButton>
    </ButtonPanelContainer>
  )
}

export default ButtonPanel
